export default "__VITE_ASSET__Bpylxqnz__"